import React, { Component } from "react";
import PageContent from "@my-dld/components/PageContent";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { RadioInput } from "@my-dld/components/RadioInput";
import { FinLookup, FinRefundLookup, RePrintRequestModal } from "../../../apis/financeDep/entities";
import * as FinanceDepApi from "../../../apis/financeDep/api";
import * as FinanceServices from "../../../apis/financeDep/services";
import { validateEmail } from "../../../apis/financeDep/services";
import { LocaleUtil } from "@eres/core";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { trackEventWithData } from "@my-dld/utils/Analytics";

const RECEIPT = {
	identity: 0,
	...LVStrings.receipt,
};
const CERTIFICATE = {
	identity: 1,
	...LVStrings.certificate,
};
const searchType = [ CERTIFICATE, RECEIPT ];

interface Props extends RoutedViewProps {

}

interface State extends RePrintRequestModal {
	selectionId: FinRefundLookup;
	errorContainer: ErrorContainer;
	certificateTypes: FinLookup[];
	certificateTypeId?: number;
}

class FeesReceipt extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			selectionId: CERTIFICATE,
			errorContainer: {},
			certificateTypes: [],
		};
	}

	componentDidMount(): void {
		showLoading();
		const procedureLookupHandler = ( response: any ) => {
			hideLoading();
			this.setState( {
				certificateTypes: FinanceServices.sortCertificateTypes( response ),
			} );
		};
		const procedureLookupExHandler = ( reason: string ) => {
			hideLoading();
		};
		FinanceDepApi.getCertificateTypes()
		.then( procedureLookupHandler )
		.catch( procedureLookupExHandler );
	}

	render() {
		const state = this.state;
		const errorContainer = this.state.errorContainer;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const kvProp = { inputClassName: "form-select", holder: this, containerClassName: "col-md-6 form-group" };
		return <>
            <div className={"container"}>
                <div className="row">
                    <RadioInput
                        holder={ this }
                        containerClassName={ "col-md-12 form-group" }
                        label={ Strings.search_by }
                        id={ "selectionId" }
                        toIdentifier={ ( item: FinRefundLookup ) => item.identity + "" }
                        formatter={ item => LocaleUtil.getLocalValue( item ) }
                        items={ searchType }
                        onValueChange={ value => {
                            this.setState( {
                                errorContainer: {},
                                recieptYear: undefined,
                                certificateYear: undefined,
                                email: undefined,
                                recieptNumber: undefined,
                                certificateNumber: undefined,
                                certificateType: undefined,
                            } );
                            this.setState( { selectionId: value } );
                            // this.setState({...resetPersonBuyer(), uaeResidenceVerified: false, ownershipType: value});
                        } }
                    />

                {
                    state.selectionId.identity === RECEIPT.identity &&
                    <>
                        <TextInputField
                                { ...filedProps }
                                id={ "recieptNumber" }
                                required={ true }
                                type={ "number" }
                                placeHolder={"e.g. 1234"}
                                containerClassName="col-xl-3 col-lg-5 col-md-6 col-sm-12 col-12 mb-3"
                                label={ Strings.receipt_number }
                                error={ errorContainer.recieptNumber }
                            />
                        <TextInputField
                                { ...filedProps }
                                id={ "recieptYear" }
                                required={ true }
                                type={ "number" }
                                maxLength={ 4 }
                                placeHolder={ "e.g. 2024" }
                                containerClassName="col-xl-3 col-lg-5 col-md-6 col-sm-12 col-12 mb-3"
                                label={ Strings.receipt_year }
                                error={ errorContainer.recieptYear }
                            />
                    </>
                }
                {
                    state.selectionId.identity === CERTIFICATE.identity &&
                    <>
                            <PickerInput
                                { ...kvProp }
                                label={ Strings.certificate_type }
                                id={ "certificateType" }
                                items={ state.certificateTypes }
                                toIdentifier={ ( item: FinLookup ) => item.Identity + "" }
                                containerClassName={"col-xl-3 col-lg-5 col-md-6 col-sm-12 col-12 mb-3"}
                                required={ true }
                                formatter={ ( item ) => LocaleUtil.getLocalValue( { en: item.NameEn, ar: item.NameAr } ) }
                                error={ errorContainer.certificateType }
                                onValueChange={ ( item?: FinLookup ) => {
                                    this.setState( { certificateTypeId: item?.Identity } );
                                } }
                            />

                            <TextInputField
                                { ...filedProps }
                                id={ "certificateNumber" }
                                required={ true }
                                type={ "number" }
                                maxLength={ 10 }
                                placeHolder={ "e.g. 1234" }
                                containerClassName="col-xl-3 col-lg-5 col-md-6 col-sm-12 col-12 mb-3"
                                label={ Strings.certificate_number }
                                error={ errorContainer.certificateNumber }
                            />

                            <TextInputField
                                { ...filedProps }
                                id={ "certificateYear" }
                                required={ true }
                                type={ "number" }
                                maxLength={ 4 }
                                placeHolder={ "e.g. 2024" }
                                containerClassName="col-xl-3 col-lg-5 col-md-6 col-sm-12 col-12 mb-3"
                                label={ Strings.certificate_year }
                                error={ errorContainer.certificateYear }
                            />

                    </>
                }
                    <TextInputField
                        { ...filedProps }
                        id={ "email" }
                        required={ true }
                        type={ "text" }
                        placeHolder={ "e.g. example@example.com" }
                        containerClassName="col-xl-3 col-lg-5 col-md-6 col-sm-12 col-12 mb-3"
                        label={ Strings.email }
                        error={ errorContainer.email }
                    />
                <div className="mt-3">
                    <button
                        className="btn btn_1 btn_style1" data-bs-target="#buyerOTPVerification"
                        data-bs-toggle="modal" onClick={ this.onContinue }>{ Strings.send_receipt }
                    </button>
                    <button className="btn btn-grey btn_style1 ms-2 me-2" onClick={ this.onClose }>{ Strings.close }</button>
                    </div>
                </div>
			</div>

		</>;
	}

	validateForm = () => {
		let isValid = true;
		let errorViews: ErrorContainer = {};
		const state = this.state;
		if ( state.selectionId.identity === RECEIPT.identity ) {
			isValid = checkNonEmpty( state, "recieptNumber", errorViews ) && isValid;
			if (!isValid) errorViews.recieptNumber = Strings.please_enter_receipt_number;
			isValid = checkNonEmpty( state, "recieptYear", errorViews ) && isValid;
			if (!isValid) errorViews.recieptYear = Strings.please_enter_receipt_year;
		} else {
			isValid = checkNonEmpty( state, "certificateType", errorViews ) && isValid;
			if (!isValid) errorViews.certificateType = Strings.please_select_certificate_type;
			isValid = checkNonEmpty( state, "certificateNumber", errorViews ) && isValid;
			if (!isValid) errorViews.certificateNumber = Strings.please_enter_certificate_year;
			isValid = checkNonEmpty( state, "certificateYear", errorViews ) && isValid;
			if (!isValid) errorViews.certificateYear = Strings.please_enter_certificate_year;
		}
		isValid = checkNonEmpty( state, "email", errorViews ) && isValid;
		if (!isValid) errorViews.email = Strings.please_enter_valid_email_address;
		if ( isValid ) {
			isValid = validateEmail( errorViews, state, "email" ) && isValid;
			if (!isValid) errorViews.email = Strings.please_enter_valid_email_address;
		}
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};

	onContinue = () => {
		if ( this.validateForm() ) {
			showLoading();
			const state = this.state;
			const selectionId = state.selectionId.identity;
			const request: RePrintRequestModal = {
				email: this.state.email,
				certificateType: selectionId === CERTIFICATE.identity ? state.certificateTypeId : undefined,
				certificateNumber: selectionId === CERTIFICATE.identity ? state.certificateNumber : undefined,
				recieptNumber: selectionId === RECEIPT.identity ? state.recieptNumber : undefined,
				certificateYear: selectionId === CERTIFICATE.identity ? Number( state.certificateYear ) : undefined,
				recieptYear: selectionId === RECEIPT.identity ? Number( state.recieptYear ) : undefined,
			};
			FinanceDepApi.sendMailReceipt( request ).then( resp => {
				hideLoading();
				trackEventWithData( "ResendReceipt", "Success", { email: request.email, source: "PublicService" } );
				showMessage( Strings.receipt_sent_to_given_email );
				this.setState( {
					errorContainer: {},
					recieptYear: undefined,
					certificateYear: undefined,
					email: undefined,
					recieptNumber: undefined,
					certificateNumber: undefined,
					certificateType: undefined,
				} );
			} ).catch( ex => {
				hideLoading();
				trackEventWithData( "ResendReceipt", "Failed", { email: request.email, source: "PublicService" } );
				showMessage( ex.toString() );
			} );
		}
	};

	onClose = () => {
		this.props.history.goBack();
	};
}


export default FeesReceipt;
